import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { TopgradserviceService } from '../../../topgradservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-employer-register',
  templateUrl: './employer-register.component.html',
  styleUrls: ['./employer-register.component.scss']
})
export class EmployerRegisterComponent implements OnInit {
  registerEmpForm: FormGroup;
  pass: String = 'password';
  cpass: String = 'password';
  emailExists: boolean = false;
  forgetForm:boolean = false;

  constructor(private fb: FormBuilder,
    private service: TopgradserviceService,
    private router: Router) {
    this.registerEmpForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,8}$')]],
      password: ['', [Validators.required,Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/)
      ]],
      confirm_password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/) ]],
      terms: ['', Validators.nullValidator]
    },
    { validators: this.passwordMatchValidator('password', 'confirm_password') } // Apply the custom validator at the form group level
  )
  }

  // Custom Validator to match password and confirm_password
  passwordMatchValidator(passwordControlName: string, confirmPasswordControlName: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(passwordControlName);
      const confirmPasswordControl = formGroup.get(confirmPasswordControlName);

      if (!passwordControl || !confirmPasswordControl) return null;

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
        // If there are other validation errors, don't overwrite them
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null); // Clear the mismatch error if passwords match
      }

      return null; // Always return null at the group level
    };
  }

  ngOnInit(): void {
  }
  
  onEyeClick(field: any, type: any) {
    // console.log(field)
    if (field == 'pass') {
      this.pass = type
    }
  }


    
  onEyeClick1(field: any, type: any) {
    if (field == 'cpass') {
      this.cpass = type
    }
  }


  createAccount() {
    if (this.registerEmpForm.invalid || this.emailExists) {
      this.registerEmpForm.markAllAsTouched();
      return;
    }

    let obj = {
      email: this.registerEmpForm.controls.email.value,
      password: this.registerEmpForm.controls.password.value,
    }

    this.service.employerRegistration(obj).subscribe(res => {
      this.service.showMessage({
        message: "Employer account registered successfully"
      })
      this.forgetForm =true;
    }, err => {
        // console.log(err);
        this.service.showMessage({
          message: err.error.errors ? err.error.errors.msg : 'Something went Wrong'
        })
    })
  }

  checkEmailExists(e: any) {
    this.service.checkEmailExists(e.target.value).subscribe((res: any) => {
      this.emailExists = res
    })
  }

  gotoLogin(){
    this.router.navigate(['employer-login']);
  }
}
